import React, { useState, useMemo } from 'react';
import MUIDataTable from 'mui-datatables';

import CustomerCreditModal from 'components/Customers/CustomerCreditModal';
import CustomToolbar from 'components/CustomToolbar/CustomToolbar';

import { admin } from 'variables/userAccountTypes';

const CustomersTable = (props) => {

  const [rowsSelected, setRowsSelected] = useState([]);
  const [openCreditModal, setOpenCreditModal] = useState(false);
  const [customerInfo, setCustomerInfo] = useState({});

  const tableData = useMemo(() => {
    const initialTableData = [];

    for ( let i = 0; i < props.customers.length; i++ ) {
      const customer = props.customers[i];
      initialTableData.push({
        id: customer.id,
        displayId: customer.displayId,
        name: customer.name,
        phone: customer.phone,
        address: `${customer.city}, ${customer.country}`,
        company: customer.trn ? "Yes" : "No",
        payableAmount: customer.payableAmount
      });
    }

    return initialTableData;
    
  }, [props.customers]);

  const handleCreditModalOpen = () => {
    setCustomerInfo(tableData[rowsSelected[0]]);
    setOpenCreditModal(true);
  };

  const handleCreditModalClose = () => {
    setCustomerInfo({});
    setOpenCreditModal(false);
    setRowsSelected([]);
  };

  const columns = [
    { label: "ID", name: "displayId"},
    { label: "Name", name: "name"},
    { label: "Phone", name: "phone" },
    { label: "Address", name: "address" },
    { label: "Company", name: "company" },
    {
      label: "Pending Amount",
      name: "payableAmount",
      options: {
        filter: true,
        sort: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta) => (
          <font color={ value < 0 ? "red" : null }>{value}</font>
        )
      }
    }
  ];

  const onRowSelectionChange = (curr, all, rowsSelected) => {
    setRowsSelected(rowsSelected);
    if(rowsSelected.length === 1) {
      const customerInfo = props.customers[rowsSelected[0]];
      props.setUpdateInfo({
        id: customerInfo.id,
        name: customerInfo.name,
        phone: customerInfo.phone,
        addressLine: customerInfo.addressLine,
        city: customerInfo.city,
        country: customerInfo.country,
        trn: customerInfo.trn ? customerInfo.trn : ""
      });
    }
  };

  const customToolbarSelect = (selectedRows) => {
    return(
      <CustomToolbar
        switchy={2}
        element="Customer"
        handleCreditModalOpen={handleCreditModalOpen}
        setUpdate={props.updateCustomer}
      />
    )
  };

  const adminOptions = {
    filterType: "checkbox",
    selectableRows: "none",
  };

  const options = {
    filterType: "checkbox",
    onRowSelectionChange,
    selectableRowsOnClick: true,
    selectableRows: "single",
    customToolbarSelect,
    rowsSelected
  };

  return (
    <React.Fragment>
      <MUIDataTable
        title={"Customer List"}
        data={tableData}
        columns={columns}
        options={props.activeUserType === admin ? adminOptions : options}
      />
      { openCreditModal ?
      <CustomerCreditModal
        open={openCreditModal}
        customerInfo={customerInfo}
        user={props.user}
        salesOrders={props.salesOrders}
        closeModal={handleCreditModalClose}
      /> : null }
    </React.Fragment>
  )
};

export default CustomersTable;